/**
 * 🔥 2026-09-28 입점사 송장 배송조회 팝업 (관리자·고객·입점사 공용)
 *
 * 입점사는 택배사를 한글 이름('CJ대한통운' 등)으로 저장하므로 이름·코드 둘 다 받아서
 * 해당 택배사 공식 조회 화면을 팝업으로 연다.
 * 주소는 백엔드 OrderShipmentService.trackingUrl 과 같다(파트너 포털에서 이미 쓰는 주소).
 *
 * ⚠️ 본사(용마) 송장 조회는 각 화면의 기존 코드를 그대로 쓴다. 이 파일은 입점사 송장 버튼에서만 부른다.
 * 나중에 택배조회 API 키를 받으면 이 파일만 바꾸면 세 곳이 같이 바뀐다.
 */
const CARRIER_URLS = {
  yongma: 'https://ylis.yongmalogis.co.kr/cmm/modalDeliveryCargoTrace.do?ordno=',
  cj: 'https://trace.cjlogistics.com/next/tracking.html?wblNo=',
  hanjin: 'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnumText2=',
  lotte: 'https://www.lotteglogis.com/home/reservation/tracking/linkView?InvNo=',
  post: 'https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=',
  logen: 'https://www.ilogen.com/web/personal/trace/'
}

const CARRIER_ALIASES = {
  yongma: 'yongma', yongmalogis: 'yongma', '용마': 'yongma', '용마로지스': 'yongma',
  cj: 'cj', cjlogistics: 'cj', 'cj대한통운': 'cj', '대한통운': 'cj',
  hanjin: 'hanjin', '한진': 'hanjin', '한진택배': 'hanjin',
  lotte: 'lotte', '롯데': 'lotte', '롯데택배': 'lotte',
  post: 'post', epost: 'post', '우체국': 'post', '우체국택배': 'post',
  logen: 'logen', '로젠': 'logen', '로젠택배': 'logen'
}

export function carrierTrackingUrl(carrier, trackingNumber) {
  const no = String(trackingNumber || '').trim()
  if (!no || !carrier) return null
  const key = CARRIER_ALIASES[String(carrier).trim().toLowerCase()]
  return key ? CARRIER_URLS[key] + encodeURIComponent(no) : null
}

export function openCarrierTracking(carrier, trackingNumber) {
  const url = carrierTrackingUrl(carrier, trackingNumber)
  if (!url) {
    alert('배송조회를 지원하지 않는 택배사입니다. (' + (carrier || '택배사 없음') + ')')
    return
  }
  const w = window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,toolbar=no,menubar=no')
  // 팝업 차단 브라우저에서는 새 탭으로 대체
  if (!w) window.open(url, '_blank', 'noopener')
}
